<template>
  <v-container align-start>
    <div class="section_inner text-center pt-5">
      <v-row v-show="fazeOne">
        <v-col>
          <div class="display-18">{{ MessageToUser }}</div>
        </v-col>
        <v-col cols="12" v-show="SendCVSummary">
          <v-btn
            color="primary"
            target="_self"
            :loading="loading"
            rounded
            @click="unsubscribe"
          >
            כן
          </v-btn>
          <v-btn
            target="_self"
            :loading="loading"
            rounded
            @click="cancelUnsubscribe"
          >
            לא
          </v-btn>
        </v-col>
        <v-col cols="12" v-show="!SendCVSummary">
          <v-btn
            target="_self"
            :loading="loading"
            rounded
            @click="cancelUnsubscribe"
          >
            חזרה לעמוד הבית
          </v-btn>
        </v-col>
      </v-row>
      <v-row v-show="!fazeOne">
        <v-col>
          <div class="display-20">{{ completedMessage }}</div>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import SeoOptimization from '@/components/mixins/SeoOptimization';
import { UNSUBSCRIBE_CV_SUMMARY, UNSUBSCRIBE_CV_SUMMARY_REMOVE } from '@/lib/api.js';

export default {
  mixins: [SeoOptimization],
  layout: 'innerPage',
  name: 'sendcvsummaryremovePage',

  data() {
    return {
      loading: false,
      completedMessage: null,
      fazeOne: true,
    };
  },

  computed: {},

  async asyncData(context) {
    const { query } = context.route;
    const { sct, ref, dtt, utm_source } = query;
    try {
      let { data } = await context.$axios.get(`${UNSUBSCRIBE_CV_SUMMARY}`, {
        params: {
          sct: sct,
          ref: ref,
          dtt: dtt,
          utm_source: utm_source,
        },
      });

      if (data.IsError) {
        throw data.Errors;
      }

      if (data.IsRedirect) {
        let redirectUrl = data.RedirectTo;
        context.redirect(307, redirectUrl);
        return;
      }
      return {
        MessageToUser: data.MessageToUser,
        QueryString: data.QueryString,
        SendCVSummary: data.SendCVSummary,
        seodata: {
          metaData: data.SEO.MetaDataItems,
          pageTitle: data.SEO.title,
          breadcrumbs: data.SEO.BreadCrumbs.Keys,
        },
      };
    } catch (e) {
      context.error({
        statusCode: 404,
        path: context.route.fullPath,
        message: 'sendcvsummaryremove error page ' + e,
      });
    }
  },

  methods: {
    async unsubscribe() {
      try {
        const { data } = await this.$axios.post(
          `${UNSUBSCRIBE_CV_SUMMARY_REMOVE}`
        );
        if (data.IsError) {
          throw data.Errors;
        }
        this.fazeOne = false;
        this.completedMessage = data.Message;
      } catch (error) {
        console.log(error);
      }
    },
    cancelUnsubscribe() {
      this.$router.push('/');
    },
  },
};
</script>
